export const priceCardData = {
  sectionTitle:
    'Se você passar no SiSU 2026, a gente te devolve 100% do seu investimento',
  priceCards: [
    {
      theme: 'proenem-secondary',
      firstTitle: 'ENEM 2026',
      benefitsSummary: 'Curso para o ENEM 2026',
      strikeThroughPriceLabel: 'R$ 530,80',
      additionalStrikeThroughPriceLabel: 'por 12x sem juros de',
      mainContent: 'R$ 29,90',
      discount: 220,
      isCurrency: true,
      chipLabel: 'ATÉ R$ 220 OFF',
      virtualAssistantChipLabel: 'IA',
      courseInfoLabel: 'Plano de estudos personalizado',
      hasVirtualAssistent: false,
      knowMoreLabel: 'Saiba mais',
      listContent: [
        { disabled: false, text: 'Curso atualizado para o ENEM 2026' },
        { disabled: false, text: '12 meses de acesso' },
        {
          disabled: false,
          text: '4 Redações mensais corrigidas e comentadas por professores especializados'
        },
        { disabled: false, text: '6 simulados modelo ENEM com nota TRI' },
        { disabled: false, text: 'Banco com mais de 50 mil questões' },
        {
          disabled: false,
          text: 'Listas de questões por nível de dificuldade'
        },
        {
          disabled: false,
          text: 'Gráfico de evolução de acertos de questões'
        },
        { disabled: false, text: 'Apostila da aula completa em PDF' },
        {
          disabled: false,
          text: 'Provas dos últimos 10 anos, com resolução em vídeo'
        },
        { disabled: false, text: 'Tira-dúvidas' },
        { disabled: false, text: 'Projeto extracurriculares' },
        { disabled: true, text: 'Curso de nivelamento' },
        {
          disabled: true,
          text: 'Raio-x dos temas mais cobrados no Enem nos últimos anos'
        },
        { disabled: true, text: 'Curso do Profinho' },
        { disabled: true, text: 'Projeto Preparação Socioemocional' },
        { disabled: true, text: 'Assistente virtual de estudos' },
        {
          disabled: true,
          text: 'Aprofundamento de Matemática, Física, Química e Biologia'
        },
        { disabled: true, text: 'Aprofundamento de Redação' },
        { disabled: true, text: 'Curso sobre as especialidades médicas' },
        {
          disabled: true,
          text: 'Simulados semanais com boletins de desempenho'
        },
        {
          disabled: true,
          text: 'Resolução de questões de vestibulares de Medicina'
        },
        {
          disabled: true,
          text: 'Aulas ao vivo todos os dias'
        },
        {
          disabled: true,
          text: 'Plano de estudos sugerido'
        },
        {
          disabled: true,
          text: 'Mentoria para o ENEM'
        }
      ],
      plusLink: 'https://www.proenem.com.br/#turmas',
      buttonLabel: 'Quero assinar',
      mainButtonHref:
        'https://pay.hotmart.com/W97212646E?sck=40ea2856-9a02-439b-93b6-f75fb40cecb5%7Cfb.2.1718197000312.45073125256023898%7C'
    },
    {
      theme: 'proenem',
      firstTitle: 'EXTENSIVA 2026',
      benefitsSummary: 'Aulas ao vivo + Plataforma completa',
      strikeThroughPriceLabel: 'R$ 675,80',
      additionalStrikeThroughPriceLabel: 'por 12x sem juros de',
      mainContent: 'R$ 39,90',
      discount: 245,
      chipLabel: 'AULAS AO VIVO',
      virtualAssistantChipLabel: 'IA',
      courseInfoLabel: 'Plano de estudos personalizado',
      hasVirtualAssistent: true,
      knowMoreLabel: 'Saiba mais',
      listContent: [
        {
          disabled: false,
          text: 'Aulas ao vivo todos os dias'
        },
        {
          disabled: false,
          text: 'Plano de estudos sugerido'
        },
        { disabled: false, text: 'Curso atualizado para o ENEM 2026' },
        { disabled: false, text: '12 meses de acesso' },
        {
          disabled: false,
          text: 'Mentoria para o ENEM'
        },
        {
          disabled: false,
          text: '6 Redações mensais corrigidas e comentadas por professores especializados'
        },
        { disabled: false, text: '8 simulados modelo ENEM com nota TRI' },
        { disabled: false, text: 'Banco com mais de 50 mil questões' },
        {
          disabled: false,
          text: 'Listas de questões por nível de dificuldade'
        },
        {
          disabled: false,
          text: 'Gráfico de evolução de acertos de questões'
        },
        { disabled: false, text: 'Apostila da aula completa em PDF' },
        {
          disabled: false,
          text: 'Provas dos últimos 10 anos, com resolução em vídeo'
        },
        {
          disabled: false,
          text: 'Raio-x dos temas mais cobrados no Enem nos últimos anos'
        },
        { disabled: false, text: 'Tira-dúvidas' },
        { disabled: false, text: 'Curso de nivelamento' },
        { disabled: false, text: 'Projeto Preparação Socioemocional' },
        { disabled: false, text: 'Projeto extracurriculares' },
        { disabled: true, text: 'Curso do Profinho' },
        {
          disabled: true,
          text: 'Aprofundamento de Matemática, Física, Química e Biologia'
        },
        { disabled: true, text: 'Aprofundamento de Redação' },
        { disabled: true, text: 'Curso sobre as especialidades médicas' },
        {
          disabled: true,
          text: 'Simulados semanais com boletins de desempenho'
        },
        {
          disabled: true,
          text: 'Resolução de questões de vestibulares de Medicina'
        }
      ],
      plusLink: 'https://www.proenem.com.br/#turmas',
      buttonLabel: 'Quero assinar',
      mainButtonHref:
        'https://pay.hotmart.com/X97212917D?off=x8wn47ip&bid=1768410688759&sck=40ea2856-9a02-439b-93b6-f75fb40cecb5%7Cfb.2.1718197000312.45073125256023898%7C'
    },
    {
      theme: 'yellow',
      firstTitle: 'EXTENSIVA VIP',
      benefitsSummary: 'Extensiva + Aprofundamentos',
      strikeThroughPriceLabel: 'R$ 965,80',
      additionalStrikeThroughPriceLabel: 'por 12x sem juros de',
      mainContent: 'R$ 59,90',
      discount: 480,
      chipLabel: 'AULAS AO VIVO',
      virtualAssistantChipLabel: 'IA',
      courseInfoLabel: 'Plano de estudos personalizado',
      hasVirtualAssistent: true,
      knowMoreLabel: 'Saiba mais',
      listContent: [
        { disabled: false, text: 'Aulas ao vivo todos os dias' },
        { disabled: false, text: 'Plano de estudos sugerido' },
        { disabled: false, text: 'Curso atualizado para o ENEM 2026' },
        { disabled: false, text: '12 meses de acesso' },
        { disabled: false, text: 'Curso do Profinho' },
        { disabled: false, text: 'Mentoria para o ENEM' },
        {
          disabled: false,
          text: '8 Redações mensais corrigidas e comentadas por professores especializados'
        },
        { disabled: false, text: '10 simulados modelo ENEM com nota TRI' },
        { disabled: false, text: 'Banco com mais de 50 mil questões' },
        {
          disabled: false,
          text: 'Listas de questões por nível de dificuldade'
        },
        {
          disabled: false,
          text: 'Gráfico de evolução de acertos de questões'
        },
        { disabled: false, text: 'Apostila da aula completa em PDF' },
        {
          disabled: false,
          text: 'Provas dos últimos 10 anos, com resolução em vídeo'
        },
        {
          disabled: false,
          text: 'Raio-x dos temas mais cobrados no Enem nos últimos anos'
        },
        { disabled: false, text: 'Tira-dúvidas' },
        { disabled: false, text: 'Curso de nivelamento' },
        { disabled: false, text: 'Projeto Preparação Socioemocional' },
        { disabled: false, text: 'Projeto extracurriculares' },
        { disabled: false, text: 'Curso sobre as especialidades médicas' },
        {
          disabled: false,
          text: 'Aprofundamento de Matemática, Física, Química e Biologia'
        },
        { disabled: false, text: 'Aprofundamento de Redação' },
        {
          disabled: false,
          text: 'Simulados semanais com boletins de desempenho'
        },
        {
          disabled: false,
          text: 'Resolução de questões de vestibulares de Medicina'
        }
      ],
      plusLink: 'https://www.proenem.com.br/#turmas',
      buttonLabel: 'Quero assinar',
      mainButtonHref:
        'https://pay.hotmart.com/S97896589V?off=mm5wtzrg&sck=40ea2856-9a02-439b-93b6-f75fb40cecb5%7Cfb.2.1718197000312.45073125256023898%7C'
    }
  ]
}
